import { makeStyles } from '@material-ui/styles'

export default makeStyles(theme => ({
  divider: {
    marginTop: 30,
    marginBottom: 30
  },
  mt60: {
    marginTop: 60
  },
  mt30: {
    marginTop: 30
  },
  mt20: {
    marginTop: 20
  },
  mt10: {
    marginTop: 10
  },
  envSelect: {
    marginBottom: 20,
    textAlign: 'right'
  },
  envSelectOption: {
    cursor: 'pointer'
  },
  envSelectDivider: {
    paddingLeft: 10,
    paddingRight: 10,
    color: theme.palette.text.hint
  },
  toastsContainer: {
    width: 400,
    marginTop: theme.spacing(6),
    right: 0
  },
  notification: {
    display: 'flex',
    alignItems: 'center',
    background: 'transparent',
    boxShadow: 'none',
    overflow: 'visible'
  },
  notificationComponent: {
    paddingRight: theme.spacing(4)
  },
  progress: {
    visibility: 'hidden'
  },
  notificationCloseButton: {
    position: 'absolute',
    right: theme.spacing(2)
  },
  formGroup: {
    marginLeft: 0
  }
}))
